
import { doc, setDoc,collection,getFirestore,updateDoc,onSnapshot} from "firebase/firestore"; 







const gain=(data)=>{


  return (dispatch)=>
    {  


      const db=getFirestore()
      onSnapshot(collection(db, "teachers"), (querySnapshot) => {
        let arr=[]
        querySnapshot.forEach((doc) => {
          // console.log("gyuyy",doc.data());
         arr.push(doc.data())
          });

          dispatch(
            {
                type: "teachers",
                payload:arr
                
            }
            ) 


    });


    
   }
  }




  const gain_request=(data)=>{


    return (dispatch)=>
      {  
  
  
        const db=getFirestore()
        onSnapshot(collection(db, "request"), (querySnapshot) => {
          let arr=[]
          querySnapshot.forEach((doc) => {
            // console.log("gyuyy",doc.data());
           arr.push(doc.data())
            });
  
            dispatch(
              {
                  type: "request",
                  payload:arr
                  
              }
              ) 
  
  
      });
  
  
      
     }
    }






    const gain_user=(data)=>{


      return (dispatch)=>
        {  
    
    
          const db=getFirestore()
          onSnapshot(collection(db, "users"), (querySnapshot) => {
            let arr=[]
            querySnapshot.forEach((doc) => {
              // console.log("gyuyy",doc.data());
             arr.push(doc.data())
              });
    
              dispatch(
                {
                    type: "users",
                    payload:arr
                    
                }
                ) 
    
    
        });
    
    
        
       }
      }




// ******************************************************************************************


//  *********************************************************************************



// ================================================================

export {

  gain,gain_request,gain_user}

  
 